import { language as lan_keyboardShortcuts } from "./keyboard-shortcuts-modal";

let language = {
    // quill快捷键
    ...lan_keyboardShortcuts,

    STORE_PRODUCT_SETTING_INFO_CONFIG_PRODUCT_TITLE: "{{appName}} 可配置产品ID:",
    STORE_PRODUCT_SETTING_INFO_ALLOW_REDESIGN: "允许客户重新设计？",
    STORE_PRODUCT_SETTING_INFO_ALLOW_REDESIGN_DES: "勾选此框以允许您的客户在将产品添加到购物车之前更改产品设计。",
    STORE_PRODUCT_SETTING_INFO_MUST_REDESIGN_DES: "客户必须在将产品添加到购物车之前更改产品设计。",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_TITLE: "产品名称",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_ERROR_TIP: "请将产品名称长度设置为1到60。",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_ERROR_TIP_PATTERN: "有效的产品名仅包含字母、数字、标点符号、数学符号、空格字符、?、? 和 ?。您只能使用 %、:、& 和 + 字符各一次。",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_SHORT_DES: "店铺产品简短描述",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_SMALL: "小",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_NORMAL: "正常",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_LARGE: "大",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_HUGE: "超大",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_DES: "店铺产品描述",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_TITLE: "更新信息错误",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_content: "更新信息错误",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_content_1101173018: "有效的产品名仅包含字母、数字、标点符号、数学符号、空格字符、?、? 和 ?。您只能使用 %、:、& 和 + 字符各一次。",

};

export { language }
